import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {
  buildInteractionIdProps,
  InteractionComponentProps,
} from '../../../../../../../libs/shared/core/src/helpers/interaction/interactionHelpers';
import {center} from '../../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface CellHoverIconBaseProps extends InteractionComponentProps {
  children: ReactNode;
}

/*
 * Style.
 */

const StyledIconDiv = styled.div`
  height: 100%;
  ${center()};
`;

/*
 * Component.
 */

export const CellHoverIconBase: FC<CellHoverIconBaseProps> = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <StyledIconDiv {...buildInteractionIdProps(props.interactionId)}>{props.children}</StyledIconDiv>
);
